import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { isZendeskMessagingEnabled } from '../integrations/zendeskMessaging';

export const getAuthenticatedHomePath = (companyType?: string): string => {
  switch (companyType) {
    case 'Analytics':
      return '/analytics';
    case 'Suporte':
      return '/home/support';
    case 'Master':
      return '/home/master';
    default:
      return '/home';
  }
};

interface ChatRouteProps {
  children: ReactElement;
  companyType?: string;
  enabled?: boolean;
}

export const ChatRoute = ({
  children,
  companyType,
  enabled = isZendeskMessagingEnabled
}: ChatRouteProps) => {
  if (!enabled) {
    return <Navigate to={getAuthenticatedHomePath(companyType)} replace />;
  }

  return children;
};

